import React, { useState, useEffect, useRef } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Button, Drawer, Input, Form, InputNumber } from 'antd'
import notification from 'mrx-notification'
import styles from './CreateShipstationSetting.module.scss'
import { PropsFromRedux, connector } from './container'

const CreateShipstationSetting = (props: PropsFromRedux) => {
  const [isVisible, setVisible] = useState(false)
  const refEl = useRef<Input>(null)

  const { isLoading, createShipstationSetting } = props

  useEffect(() => {
    if (isVisible) {
      refEl.current && refEl.current.focus()
    }
  }, [isVisible])

  const showDrawer = () => {
    setVisible(!isVisible)
  }

  const [form] = Form.useForm()

  const handleClose = () => {
    setVisible(false)
    form.resetFields()
  }

  const onFinishHandler = async (values: any) => {
    const isSaved = await createShipstationSetting({
      name: values.name,
      apiKey: values.apiKey,
      apiSecret: values.apiSecret,
      storeId: parseInt(values.storeId)
    })
    if (isSaved) {
      notification.success({
        message: 'Successfully',
        description: 'Shipstation Setting was created successfully!'
      })
      handleClose()
    }
  }

  return (
    <>
      <Button type='primary' onClick={showDrawer}>
        <PlusOutlined />
        CREATE
      </Button>
      <Drawer title='Create Shipstation Setting' width='400' onClose={handleClose} visible={isVisible} forceRender>
        <Form layout='vertical' hideRequiredMark onFinish={onFinishHandler} form={form}>
          <Form.Item
            name='name'
            label='Name'
            rules={[{ required: true, message: 'Please input shipstation setting name!' }]}
          >
            <Input ref={refEl} />
          </Form.Item>
          <Form.Item
            name='apiKey'
            label='API Key'
            rules={[{ required: true, message: 'Please input shipstation setting API Key!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='apiSecret'
            label='API Secret'
            rules={[{ required: true, message: 'Please input shipstation setting API Secret!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name='storeId'
            label='Store ID'
            rules={[{ required: true, message: 'Please input shipstation setting Store ID!' }]}
          >
            <InputNumber style={{ width: '100%' }} />
          </Form.Item>
          <div
            style={{
              position: 'absolute',
              left: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right'
            }}
          >
            <Button onClick={handleClose} className={styles.createButton}>
              Close
            </Button>
            <Button type='primary' htmlType='submit' loading={isLoading}>
              Create
            </Button>
          </div>
        </Form>
      </Drawer>
    </>
  )
}

export default connector(CreateShipstationSetting)
